import { Injectable } from '@angular/core';

import * as Sentry from '@sentry/angular';

import { environment, EnvName } from '@zeusm/environment';

const getGtagScript = (key: string) => `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${key}');`;

const getFallbackFrame = (key: string) => `<iframe src="https://www.googletagmanager.com/ns.html?id=${key}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const enabled = !!(environment.envName === EnvName.PROD && environment.googleAnalyticsId);

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  initialize() {
    if (!enabled) {
      return;
    }
    try {
      const gTagScript = document.createElement('script');
      // NOTE async may be requested later
      // gTagScript.async = true;
      gTagScript.innerHTML = getGtagScript(environment.googleAnalyticsId);
      document.head.appendChild(gTagScript);

      const fallbackFrame = document.createElement('noscript');
      fallbackFrame.innerHTML = getFallbackFrame(environment.googleAnalyticsId);
      document.body.insertBefore(fallbackFrame, document.body.firstChild);
    } catch (e) {
      Sentry.captureException(e);
    }
  }
}
